<template>
  <main-sidebar :name="name" :title="$t('Edit')">
    <div class="p-4">
      <div class="vx-row">
        <div class="vx-col w-full mt-4" v-show="hasPermission(['IU ENTRY EDIT STATUS'])" >
          <label for="" class="label-text"
            >{{ $t('status') | capitalize }}
          </label>
          <v-select
            v-model="data.status_id"
            class="w-full"
            label="name"
            :placeholder="$t('status') | capitalize"
            :options="statusList"
            :reduce="(item) => item.id"
            :clearable="false"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <label for="" class="label-text"
            >{{ $t('vendor') | capitalize }}
          </label>
          <v-select
            v-model="data.provider"
            class="w-full"
            label="code"
            :placeholder="$t('provider') | capitalize"
            :options="providers"
            :reduce="(item) => item.id"
            :clearable="false"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <label for="" class="label-text"
            >{{ $t('transporter') | capitalize }}
          </label>
          <v-select
            v-model="data.transporter_id"
            class="w-full"
            label="code"
            :placeholder="$t('transporter') | capitalize"
            :options="transporters"
            :reduce="(item) => item.id"
            :clearable="false"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <label for="" class="label-text"
            >{{ $t('client') | capitalize }}
          </label>
          <v-select
            v-model="data.client"
            class="w-full"
            label="ShortName"
            :placeholder="$t('client') | capitalize"
            :options="clients"
            :reduce="(item) => item.ClientId"
            :clearable="false"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <label for="" class="label-text"
            >{{ $tc('po_number', 1) | capitalize }}
          </label>
          <vs-input
            :placeholder="$tc('po_number', 1) | capitalize"
            class="w-full"
            v-model="data.PO_number"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <label for="" class="label-text"
            >{{ $t('seguimiento') | capitalize }}
          </label>
          <vs-input
            :placeholder="$t('seguimiento') | capitalize"
            class="w-full"
            v-model="data.tracking_number"
          />
        </div>

        <div class="vx-col w-full mt-4">
          <label for="" class="label-text"
            >{{ $t('comments') | capitalize }}
          </label>
          <vs-textarea class="w-full" v-model="data.comments" />
        </div>
      </div>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="submit">
        {{ $t('save') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import client from '@/http/requests/client'
import loadOrder from '@/http/requests/loadOrder'
import entry from '@/http/requests/entry'
export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.transporters || this.loading.status || this.loading.clients || this.loading.vendors || this.loading.submit
    },
  },
  data: () => ({
    data: {},
    clients: [],
    providers: [],
    transporters: [],
    statusList:[],
    name: 'entry-edit',
    loading: {
      status:false,
      transporters:false,
      clients: false,
      providers:false,
      submit:false
    },
  }),
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.data = Object.assign({},this.entry)
    },
    submit() {
      this.loading.submit = true
      entry
        .update(this.data)
        .then( res => {
          this.loading.submit = false
          this.close()
          this.$emit('submit')
        })
        .catch( err => {
          this.showValidationErrors(err)
          this.loading.submit = false
        })
    },
    getClients() {
      this.loading.clients = true
      client
        .list()
        .then( res => {
          this.clients = res.data.clients
          this.loading.clients = false
        })
        .catch( err => {
          this.loading.clients = false
        })
    },
    getProviders() {
        this.loading.providers = true
        entry
        .getProviders()
        .then( res => {
          this.providers = res.data.providers
          this.loading.providers = false
        })
        .catch( err => {
          this.loading.providers = false
        })
    },
    getTransporters() {
        this.loading.transporters = true
      loadOrder
        .getTransporters()
        .then( res => {
          this.transporters = res.data.items
          this.loading.transporters = false
        })
        .catch( err => {
          this.loading.transporters = false
        })
    },
    getStatusList(){
        this.loading.providers = true
        entry
        .getStatusList()
        .then( res => {
          this.statusList = res.data.statusList
          this.loading.status = false
        })
        .catch( err => {
          this.loading.status = false
        })
    }
  },
  mixins: [loading],
  mounted(){
      this.getClients()
      this.getProviders()
      this.getTransporters()
      this.getStatusList()
  },
  props: {
    entry: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>